<template>
  <div class="logistics-list">
    <home-nav-bar title="物流">
      <div slot="right" class="nav-bar-right">
        <div class="title" @click="createLogistics">
          +添加物流
        </div>
      </div>
    </home-nav-bar>
    <wh-mobile-list ref="listTable" :extra-params="extraParams" class="main" data-src="/api/getLogisticsManagementJL">
      <template v-slot="{list}">
        <van-swipe-cell v-for="i in list" :key="i.id" :right-width="86">
          <div class="list-item wh-grid-between-3" @click="edit(i)">
            <van-image
              :src="i.photo|firstImgThumb"
              class="img"
              height="60"
              width="60"
            />
            <div class="info">
              <div class="info-name wh-text-overflow">
                {{ i.product }}
              </div>
              <div class="info-phone">
                <span>{{ i.receiver }}</span>
                <span>{{ i.contactPhone }}</span>
              </div>
              <div class="info-address">
                {{ i.receiptAddress }}
              </div>
            </div>
            <div class="operation">
              <div>操作人 <span>{{ i.staffName }}</span></div>
              <div>{{ formatTime(i.operatingTime, 'YYYY-MM-DD') }}</div>
            </div>
          </div>
          <template #right>
            <van-button square style="height:100%;width:86px" text="删除" type="danger" @click="delLogistics(i)" />
          </template>
        </van-swipe-cell>
      </template>
    </wh-mobile-list>
    <logistics-popup
      :form-type="popup.logistics.formType"
      :init-form-data="popup.logistics.initFormData"
      :visible.sync="popup.logistics.visible"
      @submitFormSuccess="submitFormSuccessFn"
    />
  </div>
</template>
<script>
import api from '@/api'
import { firstImgThumb } from '@/filter'
import { formatTime } from '@/utils/convert/convertTime'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import LogisticsPopup from '@/views/Logistics/components/LogisticsPopup'

export default {
  components: { HomeNavBar, WhMobileList, LogisticsPopup },
  filters: {
    firstImgThumb
  },
  data() {
    return {
      extraParams: {},
      popup: {
        logistics: {
          visible: false,
          formType: 'create',
          initFormData: {}
        }
      }
    }
  },
  methods: {
    formatTime,
    createLogistics() {
      this.popup.logistics.visible = true
      this.popup.logistics.formType = 'create'
    },
    edit(i) {
      api.getGetLogisticsInfoJL({ id: i.id }).then(({ data }) => {
        this.popup.logistics.visible = true
        this.popup.logistics.formType = '编辑物流'
        this.popup.logistics.initFormData = {
          ...data, goods: data.goods.map(i => ({ ...i, flag: true }))
        }
      })
    },
    submitFormSuccessFn(flag) {
      if (flag) {
        this.$refs.listTable.onRefresh()
      }
    },
    delLogistics(i) {
      this.$dialog.confirm({
        title: '是否删除该物流记录'
      })
        .then(() => {
          const params = {
            ids: [i.id]
          }
          api.deleteLogisticsManagementJL(params).then(res => {
            this.$refs.listTable.onRefresh()
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>
<style lang="less" scoped>
.logistics-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  .nav-bar-right {
    .title {
      color: #20CAA0;
    }
  }
  .main {
    padding: 10px 0;
    .list-item {
      background-color: #fff;
      width: 100%;
      height: 92px;
      padding: 16px;
      margin-bottom: 8px;
      .img {
        width: 60px;
      }
      .info {
        width: 100%;
        padding: 0 20px;
        height: 100%;
        //width: calc(100% - 150px);
        font-size: 14px;
        display: grid;
        color: #BBBBBB;
        flex-direction: column;
        justify-content: space-between;
        .info-name {
          font-size: 14px;
          color: #323332;
        }
        .info-phone {
          font-size: 14px;
          span {
            margin-right: 13px;
          }
        }
        .info-address {
          font-size: 14px;
        }
      }
      .operation {
        display: grid;
        width: 100px;
        height: 100%;
        align-content: space-around;
        font-size: 13px;
        > div:first-child {
          color: #20CAA0;
          span {
            color: #323332;
          }
        }
        > div:last-child {
          font-size: 12px;
          color: #323332;
        }
      }
    }
  }
}
.wh-grid-between-3 {
  display: grid;
  grid-template-columns: auto 1fr 100px;
  justify-content: space-between;
}
</style>
